module.exports = __webpack_public_path__ + "static/media/206.6ea75fa8.jpg";